import React, { Suspense, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { HomeHeader } from '../cmps/home-header'
import { loadBoards, saveBoard } from '../store/board.actions'
import { boardService } from '../services/board.service'
import { AiOutlinePlus } from 'react-icons/ai'
import { Loader } from '../cmps/loader'

export default function BoardGridPage() {
    const boards = useSelector(storeState => storeState.boardModule.boards)
    const loggedinUser = useSelector(storeState => storeState.userModule.user)
    const navigate = useNavigate()

    useEffect(() => {
        if (loggedinUser) loadBoards()
    }, [loggedinUser])

    if (!loggedinUser) return <Loader />

    return (
        <Suspense fallback={<Loader />}>
            <HomeHeader boards={boards} />
            <section className='home-page home-logged-in'>
                <div className='home-content layout'>
                    <div className="headers-container flex column space-between">
                        <h1 className='main-title'>
                            <span>Welcome back,</span>
                            <span>{loggedinUser.fullname}</span>
                        </h1>
                        <h2 className='secondary-title'>Select a board to continue working</h2>
                    </div>
                    <div className='board-grid'>
                        {boards.map(board => (
                            <Link to={`/board/${board._id}`} key={board._id} className='board-card'
                                onClick={() => localStorage.setItem('lastBoardId', board._id)}>
                                <span className='board-card-title'>{board.title}</span>
                            </Link>
                        ))}
                        <div className='board-card board-card-add' onClick={async () => {
                            const newBoard = boardService.getEmptyBoard()
                            const savedBoard = await saveBoard(newBoard)
                            if (savedBoard && savedBoard._id) {
                                localStorage.setItem('lastBoardId', savedBoard._id)
                                navigate(`/board/${savedBoard._id}`)
                            }
                        }}>
                            <AiOutlinePlus className='icon' />
                            <span>New Board</span>
                        </div>
                    </div>
                </div>
            </section>
        </Suspense>
    )
}
